import { api } from './api';

const makeRoleHeaders = (userRoleUuid) => {
    if (!userRoleUuid) {
        throw new Error('Missing active user role UUID.');
    }

    return {
        'USER-ROLE': userRoleUuid
    };
};

export const createCallLog = async ({ userRoleUuid, srcRoleUuid, dstRoleUuid }) =>
    api.post(
        '/calls',
        {
            src_uuid: srcRoleUuid,
            dst_uuid: dstRoleUuid
        },
        {
            headers: makeRoleHeaders(userRoleUuid)
        }
    );

export const updateCallLog = async ({ userRoleUuid, payload }) =>
    api.patch('/calls', payload, {
        headers: makeRoleHeaders(userRoleUuid)
    });

export const listCallLogs = async ({
    userRoleUuid,
    states,
    paginationToken,
    paginationLimit
} = {}) =>
    api.get('/calls', {
        headers: {
            ...makeRoleHeaders(userRoleUuid),
            ...(paginationToken ? { 'PAGINATION-TOKEN': paginationToken } : {}),
            ...(paginationLimit ? { 'PAGINATION-LIMIT': String(paginationLimit) } : {}),
            ...(Array.isArray(states) && states.length > 0
                ? { 'CVP-QUERY-CALL-STATE': JSON.stringify(states) }
                : {})
        }
    });

export const sendCallPush = async ({ userRoleUuid, dstRoleUuid }) =>
    api.post(
        '/calls/push',
        {
            dst_uuid: dstRoleUuid
        },
        {
            headers: makeRoleHeaders(userRoleUuid)
        }
    );
